"use strict";
exports.__esModule = true;
var floor_1 = require("./floor");
var getRandomRate = function () {
    return (0, floor_1["default"])(Math.random(), 4);
};
exports["default"] = getRandomRate;
